import React from 'react';
import { PlusIcon } from '@heroicons/react/24/solid';

interface AddButtonProps {
    text: string;
    onClick: () => void;
    className?: string;
}

const AddButton: React.FC<AddButtonProps> = ({ text, onClick, className }) => {
    return (
        <button
            onClick={onClick}
            className={`flex items-center gap-2 px-4 py-2 bg-red-600 border border-red-600 text-white rounded-md hover:bg-white hover:text-red-600 transition ${className}`}
        >
            <PlusIcon className="w-5 h-5" />
            <span>{text}</span>
        </button>
    );
};

export default AddButton;
